import authApi from '../../utils/AxiosConfig';
import authHeader from '../../utils/authHeader';

const API_URL = '/payments';

// Create Payment Intent
const createPaymentIntent = async (amount, token) => {
    const response = await authApi.post(
        `${API_URL}/create-payment-intent`,
        { amount },
        { headers: authHeader(token) }
    );
    return response.data;
};

const paymentService = { createPaymentIntent };

export default paymentService;
